import React from 'react'
import { Modal } from 'lp-components'

function NotificationStatusModal({ onClose }) {
  return (
    <Modal id="benefit-distribution-status-modal" onClose={onClose}>
      <div className="benefit-distribution-status-modal_info">
        <h2>Status types</h2>
      </div>
      <div className="benefit-distribution-status-modal_info__text">
        <h5>In progress</h5>
        <p>
          We received your request, and your notification materials are being
          prepared to send.
        </p>
        <h5>Sent</h5>
        <p>Your materials have been mailed to the participant.</p>
        <h5>Delivered</h5>
        <p>Your materials were successfully delivered to the participant.</p>
        <h5>Return to sender</h5>
        <p>
          Your materials could not be delivered and were returned to sender.
        </p>
        <h5>Not delivered</h5>
        <p>
          Your materials couldn’t be delivered and were not returned. This may
          be due to an invalid address or recipient refusal.
        </p>
      </div>
      <div className="benefit-distribution-status-modal_button">
        <button className="button-primary" type="button" onClick={onClose}>
          Close
        </button>
      </div>
    </Modal>
  )
}

export default NotificationStatusModal
